import { connect } from 'react-redux'
import { getLocalization } from 'base/lib/localization'

function mapStateToProps() {
  const { currency } = getLocalization()

  return {
    currentCurrency: currency,
    currencyIsUSD: currency === 'USD',
  }
}

export function currencyAware(component) {
  return connect(mapStateToProps, null)(component)
}
